import { render, staticRenderFns } from "./HistoryDataView.vue?vue&type=template&id=0cfe1820"
import script from "./HistoryDataView.vue?vue&type=script&lang=js"
export * from "./HistoryDataView.vue?vue&type=script&lang=js"
import style0 from "./HistoryDataView.vue?vue&type=style&index=0&id=0cfe1820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports